import { gateway } from "../../../gateway";

export const deleteRemindersConfig = async (uid: string) => {
    const response = await gateway.delete(`reminders-settings/${uid}`);
    return response.data;
};